import _classCallCheck from "/codebuild/output/src4135/src/s3/00/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4135/src/s3/00/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4135/src/s3/00/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src4135/src/s3/00/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src4135/src/s3/00/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { R as RequestHandler, f as getUrlByMask, m as matchRequestUrl, g as getPublicUrlFromRequest, h as prepareRequest, i as prepareResponse, j as getTimestamp, k as getStatusCodeColor } from './RequestHandler-deps.js';
import { a as set, s as status, b as json, d as delay, f as fetch } from './fetch-deps.js';
import { c as cookie, b as body, t as text, x as xml } from './xml-deps.js';
/**
 * Performs a case-insensitive comparison of two given strings.
 */

function isStringEqual(actual, expected) {
  return actual.toLowerCase() === expected.toLowerCase();
}

var RESTMethods;

(function (RESTMethods) {
  RESTMethods["HEAD"] = "HEAD";
  RESTMethods["GET"] = "GET";
  RESTMethods["POST"] = "POST";
  RESTMethods["PUT"] = "PUT";
  RESTMethods["PATCH"] = "PATCH";
  RESTMethods["OPTIONS"] = "OPTIONS";
  RESTMethods["DELETE"] = "DELETE";
})(RESTMethods || (RESTMethods = {}));

var restContext = {
  set: set,
  status: status,
  cookie: cookie,
  body: body,
  text: text,
  json: json,
  xml: xml,
  delay: delay,
  fetch: fetch
};
/**
 * Request handler for REST API requests.
 * Provides request matching based on method and URL.
 */

var RestHandler = /*#__PURE__*/function (_RequestHandler) {
  _inherits(RestHandler, _RequestHandler);

  var _super = _createSuper(RestHandler);

  function RestHandler(method, mask, resolver) {
    var _this;

    _classCallCheck(this, RestHandler);

    _this = _super.call(this, {
      info: {
        header: "".concat(method, " ").concat(mask),
        mask: mask,
        method: method
      },
      ctx: restContext,
      resolver: resolver
    });

    _this.checkRedundantQueryParameters();

    return _this;
  }

  _createClass(RestHandler, [{
    key: "checkRedundantQueryParameters",
    value: function checkRedundantQueryParameters() {
      var _this$info = this.info,
          method = _this$info.method,
          mask = _this$info.mask;
      var resolvedMask = getUrlByMask(mask);

      if (resolvedMask instanceof URL && resolvedMask.search !== '') {
        var queryParams = [];
        resolvedMask.searchParams.forEach(function (_, paramName) {
          queryParams.push(paramName);
        });
        console.warn("[MSW] Found a redundant usage of query parameters in the request handler URL for \"".concat(method, " ").concat(mask, "\". Please match against a path instead, and access query parameters in the response resolver function:\n\nrest.").concat(method.toLowerCase(), "(\"").concat(resolvedMask.pathname, "\", (req, res, ctx) => {\n  const query = req.url.searchParams\n").concat(queryParams.map(function (paramName) {
          return "  const ".concat(paramName, " = query.get(\"").concat(paramName, "\")");
        }).join('\n'), "\n})      "));
      }
    }
  }, {
    key: "parse",
    value: function parse(request) {
      return matchRequestUrl(request.url, this.info.mask);
    }
  }, {
    key: "getPublicRequest",
    value: function getPublicRequest(request, parsedResult) {
      return Object.assign(Object.assign({}, request), {
        params: parsedResult.params || {}
      });
    }
  }, {
    key: "predicate",
    value: function predicate(request, parsedResult) {
      return isStringEqual(this.info.method, request.method) && parsedResult.matches;
    }
  }, {
    key: "log",
    value: function log(request, response) {
      var publicUrl = getPublicUrlFromRequest(request);
      var loggedRequest = prepareRequest(request);
      var loggedResponse = prepareResponse(response);
      console.groupCollapsed('[MSW] %s %s %s (%c%s%c)', getTimestamp(), request.method, publicUrl, "color:".concat(getStatusCodeColor(response.status)), response.status, 'color:inherit');
      console.log('Request', loggedRequest);
      console.log('Handler:', {
        mask: this.info.mask,
        resolver: this.resolver
      });
      console.log('Response', loggedResponse);
      console.groupEnd();
    }
  }]);

  return RestHandler;
}(RequestHandler);

function createRestHandler(method) {
  return function (mask, resolver) {
    return new RestHandler(method, mask, resolver);
  };
}

var rest = {
  head: createRestHandler(RESTMethods.HEAD),
  get: createRestHandler(RESTMethods.GET),
  post: createRestHandler(RESTMethods.POST),
  put: createRestHandler(RESTMethods.PUT),
  delete: createRestHandler(RESTMethods.DELETE),
  patch: createRestHandler(RESTMethods.PATCH),
  options: createRestHandler(RESTMethods.OPTIONS)
};
export { RestHandler as R, RESTMethods as a, restContext as b, isStringEqual as i, rest as r };